import { Link } from 'react-router-dom';
import { useContext } from 'react';

import { ActionTypes } from '@/components/Store.d';
import { Context } from '@/components/Store';
import { getTiers } from '@/lib/mapping';
import { setMinimumAmount } from '@/lib/util';
import { supporterRoutes } from '@/lib/config';
import type { SupporterPeriodProps } from '@/components/SupporterPeriod/SupporterPeriod.d';

const SupporterPeriod = (props: SupporterPeriodProps) => {
  const [ state, dispatch ] = useContext(Context);

  const handleChange = () => {
    dispatch({
      type: ActionTypes.supporterChangePeriod,
      payload: {
        selection: props.id,
        tiers: getTiers(props.id)
      }
    });

    dispatch({
      type: ActionTypes.supporterCustomMinimumAmount,
      payload: {
        key: 'supporter.minimumAmount',
        value: setMinimumAmount(state.supporter.selection.period)
      }
    });
  };

  return (
    <li className={state.supporter.selection.period === props.id ? 'selected' : undefined}>
      <Link
        onClick={handleChange}
        to={`/produkt/${supporterRoutes[props.id]}`}
      >
        {props.labelText}
      </Link>
    </li>
  );
};

export { SupporterPeriod };
